import service from './../service.js';

export default {
    // getProvinces() {
    //     return service.get('/baos/provinces');
    // },
    // getCities(province_code){
    //     return service.get("baos/city/" + province_code);
    // },
    // getBarangays(city_code){
    //     return service.get("/baos/brgy/" + city_code);
    // },
    getProvinces() {
        return service.get('/reference/psgc/provinces');
    },
    getCities(province_code){
        return service.get("/reference/psgc/city/" + province_code);
    },
    getBarangays(city_code){
        return service.get("/reference/psgc/barangays/" + city_code);
    },
    getRCBCInfo(){
        return service.get("/baos/rcbc");
    },
    getPNBInfo(){
        return service.get("/baos/pnb");
    },
    submitRCBC(data){
        return service.post("/baos/rcbc", data);
    },
    submitPNB(data){
        return service.post("/baos/pnb", data);
    },
    getBranches() {
        return service.get("/reference/branches");
    },
}